import { useEffect } from 'react';
import { useAuth } from '@/auth/useAuth';
import { userApi } from '@/api/userApi';
import { useTheme, fromServerPreference } from './ThemeContext';

/**
 * Bridges the (auth-unaware) ThemeProvider with the authenticated user: once
 * logged in, it loads the theme preference saved in the DB and applies it
 * without re-persisting. Must be rendered inside the Keycloak provider.
 * Renders nothing.
 */
const ThemeSync = () => {
  const { isAuthenticated } = useAuth();
  const { setMode } = useTheme();

  useEffect(() => {
    if (!isAuthenticated) return;
    let cancelled = false;
    userApi
      .getCurrentUser()
      .then((user) => {
        const mode = fromServerPreference(user.uiThemePreference);
        if (!cancelled && mode) {
          setMode(mode, false); // apply server value without echoing it back
        }
      })
      .catch(() => {
        /* ignore — fall back to the locally stored / default theme */
      });
    return () => {
      cancelled = true;
    };
  }, [isAuthenticated, setMode]);

  return null;
};

export default ThemeSync;
